import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import Icon from 'gu-ui-kit/Icon'
import styles from 'components/Nav/nav.module.scss'
import clsx from 'clsx'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { GET_2FA } from 'modules/User/Security/2fa/types'

const SecurityLink = React.forwardRef(
  ({ className, activeClassName, exact, to, children, ...rest }, ref) => {
    const {
      initialized = false,
      enabled = false,
      is_2fa_available = false,
    } = useSelector((state) => {
      const combined = { ...state['user/2fa'], ...state['user/profile'] }
      return {
        initialized: combined.initialized,
        enabled: combined.enabled,
        is_2fa_available: combined.is_2fa_available,
      }
    }, shallowEqual)
    const dispatch = useDispatch()

    useEffect(() => {
      if (initialized) {
        return
      }
      dispatch({ type: GET_2FA })
    }, [dispatch, initialized])

    return (
      <NavLink
        activeClassName={activeClassName}
        className={className}
        exact={exact}
        innerRef={ref}
        to={to}
        {...rest}
      >
        {children}
        {is_2fa_available && initialized && !enabled && (
          <span
            className={clsx(
              styles['nav__link-part'],
              styles['nav__notification'],
              styles['nav__notification_warning'],
            )}
          >
            <Icon
              name={'status warning'}
              size={'sm'}
            />
          </span>
        )}
      </NavLink>
    )
  },
)

SecurityLink.displayName = 'SecurityLink'

export default SecurityLink

SecurityLink.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
}
